import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ConnectorsService } from '../services/connectors.service';
import { Router } from '@angular/router';
import { ItsmNames } from 'src/app/pages/connectors/constants';
@Component({
    selector: 'app-connector-renderer',
    template: `
        <div>
            <div class="icon-show">
                <div (click)="editModal('edit-modal')"
                     *ngIf="this.router.url === '/connectors/itsm-manage-connectors'">
                    <collab-comp-img-generator
                        fontClassName="icon-Edit"
                        fontSize="icon--md"
                    ></collab-comp-img-generator>
                </div>
                <div (click)="deleteModal('delete-modal')" 
                    *ngIf="this.router.url === '/connectors/itsm-manage-connectors'">
                    <collab-comp-img-generator
                        fontClassName="icon-Delete"
                        fontSize="icon--md"
                    ></collab-comp-img-generator>
                </div>
                <div>
                    <collab-comp-img-generator
                        fontClassName="icon-Edit"
                        fontSize="icon--md"
                        class="nav-icon"
                        altText="texticon"
                        [ngClass]="'icon-enable'"
                        *ngIf="this.router.url === '/connectors/monitoring-manage-connectors'"
                        (click)="onEditMonitoringServices()"
                    ></collab-comp-img-generator>
                </div>
                <div >
                    <collab-comp-img-generator
                        fontClassName="icon-Delete"
                        fontSize="icon--md"
                        class="nav-icon"
                        altText="texticon"
                        [ngClass]="'icon-enable'"
                        *ngIf="this.router.url === '/connectors/monitoring-manage-connectors'"
                        (click)="deleteMonitoringServices()"
                    ></collab-comp-img-generator>
                </div>
            </div>
        </div>
    `,
    styles: [
        `
            .icon-show {
                display: flex;
                gap: 10px;
                padding-top: 7px;
            }
            collab-comp-img-generator {
                color: #3d3db8;
                cursor: pointer;
            }
        `,
    ],
})
export class ConnectorActionButtonRendererComponent implements ICellRendererAngularComp {
    constructor(private connectorServices: ConnectorsService, public router: Router) { }
    params: any;
    showIcon: any;
    agInit(params: any): void {
        if (params.node.data) {
            this.showIcon = true;
        } else {
            this.showIcon = false;
        }
        this.params = params;
    }
    refresh(params: any) {
        return true;
    }
    deleteModal($event: any) {
        this.connectorServices.deleteConnectorModal.next(this.params.data);
    }

    editModal($event: any) {
        const params: any = {
            itsm: this.params.data.itsmName,
            mode: 'edit',
        };

        if (this.params.data.itsmName === ItsmNames.jira) {
            params.projectName = this.params.data.projectName;
        }
        this.router.navigate(['/connectors/jira-connector'], {
            queryParams: params,
        });
    }

    deleteMonitoringServices(){
        const apimId = this.params.data.requestId;
        if (apimId !== null && apimId !== undefined) {
            this.connectorServices.deleteConnector.next(apimId);
        }
    }

    // onEditMonitoringServices(){
    //     const params: any = {
    //         mode: 'edit',
    //     };

    //     this.router.navigate(['/connectors/monitoring-services-form'], {
    //         queryParams: params,
    //     });

    // }

    onEditMonitoringServices() {
  this.router.navigate(['/connectors/monitoring-services-form'], {
    queryParams: {
      mode: 'edit',
      requestId: this.params.data.requestId,
    }
  });
}

}
